<template>
  <div class="container flex flex-col min-h-screen">
    <div class="mb-3 py-3">
      <!-- <img
        src="@/assets/img/logo.svg"
        alt="logo oab diario"
        class="w-32 lg:w-48 mx-auto"
      /> -->
    </div>
    <div class="flex-1 ">
      <h2 class="text-2xl font-medium text-center">
        <slot name="title" class="text-red-400" />
      </h2>
      <div class="px-4">
        <slot />
      </div>
      <div class="px-0">
        <slot name="no-padding" />
      </div>
    </div>
    <navigationBottom />
  </div>
</template>

<script>
import Nav from "../components/Nav";

export default {
  name: "layout-default",
  components: {
    navigationBottom: Nav
  }
};
</script>
